// Module
var code = "<div class=cover style=background-image:url({{$ctrl.cover.url}})> <div class=cover-item> <div ng-transclude></div> </div> </div> <div class=cover-copyright> {{$ctrl.cover.copyright}} </div> ";
// Exports
module.exports = code;